import { EMIT } from '../../constants/ActionTypes';

// Common actions
export const subscribeUnderlyingLiveFeed = () => (dispatch) => {
  dispatch({
    type: EMIT,
    payload: {
      method: 'subscribe_underlying_live_feed',
    },
  });

  return Promise.resolve();
};

export const unsubscribeUnderlyingLiveFeed = () => (dispatch) => {
  dispatch({
    type: EMIT,
    payload: {
      method: 'unsubscribe_underlying_live_feed',
    },
  });

  return Promise.resolve();
};
